import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { VisitorProvider } from '../providers/visitor/visitor';
import { ToastProvider } from '../providers/toast/toast';
import { ModalController,  Platform } from 'ionic-angular';
import { VisitorModalPage } from '../pages/visitor-modal/visitor-modal';
import { SurveyModalPage } from '../pages/survey-modal/survey-modal';
import { environment } from '../environments/environment';
declare let window: any; 

@Injectable()
export class HandleNotificationService {
  message: string;
  notificationId: string;
  pnInterval: any;
  isAndroid= true;
  constructor(
    private visitorProvider: VisitorProvider,
    private toast: ToastProvider,
    private modalCtrl: ModalController,
    private storage: Storage,
    private platform: Platform
    ) {
      this.isAndroid = this.platform.is('android');
      if(environment.runAs == environment.constant.WEB){
        var self = this;
        console.log("Starting set interval for pn_web =>");        
        this.pnInterval = setInterval(function() {
          let pnWeb = localStorage.getItem('pn_web');
          if(environment.debug) console.log("HandleNotificationService->constructor()->setInterval() pn_web => ", pnWeb);            
          if(pnWeb){
            let pnWebObj = JSON.parse(pnWeb);
            self.displayNotification(pnWebObj.payload, pnWebObj.action, pnWebObj.message, self);
            localStorage.removeItem('pn_web');
          }
        }, 1000);
      } ;

    //  var data = {
    //    type:'visit',
    //    id : 224,
    //    message : 'Aniket Singh (7011283041) is asking you to allow for visit for meeting.'
    //  }
    //  this.visitorDetail(data.id,data.message);
  }

  handleNotifications(data){
    if(environment.debug) console.log("Enter handleNotifications(data) =>", data);
    var payload = (data && data.notification.notification) ? data.notification.notification : data.notification;
    if(payload && payload.notificationID && payload.notificationID == this.notificationId){
      if(environment.debug) console.log("Notification already processed !!");
      return;
    }
    this.notificationId = (payload && payload.notificationID) ? payload.notificationID : "";
    this.message = (payload && payload.body) ? (payload.body) : "";
    var payloadData = payload && payload.additionalData && payload.additionalData.data ? payload.additionalData.data : null;
    var actionId = (data && data.action && data.action.type == 1) ? (data && data.action.actionID) : null;
    
    this.displayNotification(payloadData, actionId, this.message, null);
  }

  displayNotification(payloadData, action, message, self){
    if(!self) self = this;
    if(environment.debug) console.log("Enter displayNotification(payloadData, action, message) =>", payloadData, action, message);       
    if(environment.switchToWeb){
      let pn : any = {action:action, message:message, payload: {} }
      if(payloadData){
      pn.payload.id = payloadData.id;
      pn.payload.type = payloadData.type
      }
      localStorage.setItem('pn_web', JSON.stringify(pn));
      if(environment.debug) console.log("displayNotification()->setItem(pn_web) =>", localStorage.getItem('pn_web'));
      return;
    }
    if (action && payloadData && payloadData.id) {
      if(environment.debug) console.log("Enter handleNotifications->payload =>", payloadData);
      switch (action) {
        case 'acceptvisit':
          self.acceptVisit(payloadData)
          break;
        case 'rejectvisit':
          self.rejectVisit(payloadData)
          break;
        default:
          break;
      }
    }else{
      if(environment.debug) console.log("Calling displayPayloadData()=>", payloadData, message);      
      self.displayPayloadData(payloadData, message, self);
    }
  }

  acceptVisit(data){    
    this.visitorProvider.allow(data.id).then(val => {
      if(val.status == "success"){
        let profileModal = this.modalCtrl.create(VisitorModalPage, {
          message: "This visit is accepted!",
          title: 'notification'
        });
        profileModal.present();
      }else {
        this.toast.presentToast(val.message ? val.message : "Unable to process the visit")
      }
    });
  }

  rejectVisit(data){
    this.visitorProvider.deny(data.id).then(val => {
      if(val.status == "success"){
        let profileModal = this.modalCtrl.create(VisitorModalPage, {
          message: "The visit is rejected",
          title: 'notification'
        });
        profileModal.present();
      }else {
        this.toast.presentToast(val.message ? val.message : "Unable to process the visit");
      }
    });
  }

  displayPayloadData(data, message, self){
    if(!self) self = this;
    if(environment.debug) console.log("Enter displayPayloadData(data) =>", data);
    let type = data ? data.type : 'default';
    switch ( type ) {
      case 'COMPLAINT':
        self.complaintDetail(data.id, message);
        break;
      case 'VISIT':
        if(this.isAndroid){
          //open the visit page
          // this.navCtrl.push(VisitorTabsPage);
          self.defaultView(data, message+' Goto visit tab to see details.')
        }else{
          self.visitorDetail(data.id, message)
        }
        break;
      case 'STAFF':
        self.staffDetail(data.id, message);
        break;
      case 'SURVEY':
        localStorage.setItem('surveyFlag', '1');
        self.surveyDetail(data.id, message);
        break;
      default:
        self.defaultView(data, message)
      }
  }

  complaintDetail(id, message){
    if(environment.debug) console.log("Enter complaintDetail(id) and message=>", id, message);
    let profileModal = this.modalCtrl.create(VisitorModalPage, { 
      id, 
      message: message ? message : this.message,
      title: 'notification'
    });
    profileModal.present();
  }

  visitorDetail(id, message){
    if(environment.debug) console.log("Enter visitorDetail(id) and message=>", id, message);
    let profileModal = this.modalCtrl.create(VisitorModalPage, { 
      id, 
      message: message ? message : this.message,
      title: 'visit'
    });
    profileModal.present();
  }

  staffDetail(id, message){
    if(environment.debug) console.log("Enter staffDetail(id) and message=>", id, message);
    let profileModal = this.modalCtrl.create(VisitorModalPage, { 
      id, 
      message: message ? message : this.message,
      title: 'staff'
    });
    profileModal.present();
  }  
  surveyDetail(id, message){
    if(environment.debug) console.log("survey modal id and message =>", id, message);
    let profileModal = this.modalCtrl.create(SurveyModalPage,{
      id,
      message: message ? message : this.message,
      title: 'survey'
    })
    profileModal.present();
  }

  defaultView(data, message){
    if(environment.debug) console.log("default modal data and message =>", data, this.message, message);
    let profileModal = this.modalCtrl.create(VisitorModalPage, { 
      message: message ? message : this.message,
      title: 'notification'
    });
    profileModal.present();
  }

  switchToWeb(){
    if(environment.debug) console.log("Enter switchToWeb() =>", new Date());
    try{
    var targetUrl = environment.targetUrl;      
    this.storage.get("loginDetails").then((val) => {
      if(environment.debug) console.log("login detail from storage.get()==>", val, new Date());
      this.openUrl(targetUrl, val);
    })
    }catch(e){
      console.error("Error in switchToWeb =>",e)
    }
  }
  openUrl(targetUrl: string, loginDetail: any){
    var pollInterval;
    if(loginDetail){
      targetUrl += "&api_token="+loginDetail.api_token+'&'
      targetUrl += "id="+loginDetail.id+'&'
      targetUrl += "tenant="+ (loginDetail.tenant ? 1 : 0)
      if(environment.debug) console.log("window.open(), URL =>",targetUrl, new Date());
      var browserApp = window.open(targetUrl, '_blank', 'location=no,clearsessioncache=no,clearcache=no');
      browserApp.addEventListener( "loadstop", function() {
        pollInterval = setInterval(function() {
            let pnWeb = localStorage.getItem('pn_web');
            if(environment.debug) console.log("openUrl()-> pn_web => ", pnWeb);            
            if(pnWeb){              
              if(environment.debug) console.log("push notification found in storage =>");
              browserApp.executeScript({ code: "processWebNotification('"+pnWeb+"');"}, function(values) {
                console.log("callBack from executeScript()->processWebNotification()", values);
              });
              localStorage.removeItem('pn_web');
            }
        }, 1000)
    });            
    browserApp.addEventListener('exit', function() {
        clearInterval(pollInterval);
        clearInterval(this.pnInterval);
        console.log("value from exit ",name); 

    }); 
    }else{
      if(environment.debug)  console.log("New Login required, user is not logged in => ");
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/handle-notification.ts